import { removeClass, addClass, sameTagname, getFirstChild, getText, offsetCoordinates } from './domUtils';

const MIN_NAV_WIDTH = 350;
function handleMenu({ menuElt, mainElt, location, onUpdateLocation }) {
  let generateMenu = false;
  // Check if filling the menu is needed
  if (!getFirstChild(menuElt)) {
    const title = document.createElement('h1');
    title.innerHTML = 'Content';
    menuElt.appendChild(title);
    generateMenu = true;
  } else if (!getFirstChild(menuElt, 'UL')) {
    generateMenu = true;
  }

  const scrollMenuItems = [];
  if (generateMenu) {
    const ul = document.createElement('UL');
    const uls = [ul];
    const sections = mainElt.getElementsByTagName('SECTION');

    const isRootSection = (section) => {
      let parent = section;
      do {
        parent = parent.parentNode;
        if (sameTagname(parent.tagName, 'SECTION')) {
          return false;
        }
      } while (parent !== mainElt);
      return true;
    };
    const sectionHeaders = ['H2', 'H3', 'H4'];
    const scrollItems = Array.prototype.slice.call(sections)
      .filter(x => x.id && getFirstChild(x, sectionHeaders));
    if (!scrollItems.length) {
      return;
    }
    const lasts = [ul];
    scrollItems.forEach((section) => {
      const li = document.createElement('li');
      const liContent = document.createElement('div');
      liContent.className = 'grb-menu-content';
      const a = document.createElement('a');
      a.href = `${location && location.pathname || ''}#${section.id}`;
      const h = getFirstChild(section, sectionHeaders);
      const level = sectionHeaders.findIndex(sh => (sh === h.tagName.toUpperCase()));
      // Check a text specific to navigation was specified
      const navText = h.getElementsByClassName('grb-navtext');
      const text = navText && navText.length && getText(navText[0]) || getText(h);
      a.textContent = text;
      if (level >= uls.length) {
        for (let i = uls.length; i <= level; i += 1) {
          const cul = document.createElement('UL');
          lasts[i - 1].appendChild(cul);
          lasts.push(cul);
          uls.push(cul);
        }
      } else if (level < (uls.length - 1)) {
        uls.splice(level + 1, uls.length - level - 1);
        lasts.splice(level + 1, uls.length - level - 1);
      }
      liContent.appendChild(a);
      li.appendChild(liContent);
      lasts[level] = li;
      uls[level].appendChild(li);
      scrollMenuItems.push({
        scrollItem: section,
        li,
        a,
      });
    });
    menuElt.appendChild(ul);
  } else {
    const ul = getFirstChild(menuElt, 'UL');
    const lis = ul.getElementsByTagName('LI');
    Array.prototype.slice.call(lis).forEach((li) => {
      const a = getFirstChild(li, 'a');
      if (a) {
        let id = a.href;
        const index = id.indexOf('#');
        if (index >= 0) {
          id = id.substring(index + 1);
        }
        const scrollItem = document.getElementById(id);
        if (scrollItem) {
          scrollMenuItems.push({
            li,
            a,
            scrollItem,
          });
        }
      }
    });
  }

  let lastSelectedScrollMenuItem = null;
  const getClosestScrollMenuItem = (top) => {
    let closestBeforeIndex = -1;
    let closestBeforeDiff;
    let closestAfterIndex = -1;
    let closestAfterDiff;
    scrollMenuItems.forEach((si, index) => {
      const coord = offsetCoordinates(si.scrollItem, mainElt);
      // console.log(`${si.scrollItem.id} => ${coord.top}`);
      const diff = coord.top - top;
      // When zooming pages, positions are no more round numbers
      if (Math.abs(diff) < 2) {
        // console.log(`   Found ${si.scrollItem.id}`);
        closestBeforeIndex = index;
        closestBeforeDiff = 0;
      } else if (diff > 0) {
        if ((closestAfterIndex < 0) || (closestAfterDiff > diff)) {
          closestAfterIndex = index;
          closestAfterDiff = diff;
        }
      } else if ((closestBeforeIndex < 0) || (closestBeforeDiff < diff)) {
        closestBeforeIndex = index;
        closestBeforeDiff = diff;
      }
    });
    if (Math.abs(mainElt.scrollHeight - top - mainElt.clientHeight) < 2) {
      if (closestAfterIndex >= 0) return scrollMenuItems[closestAfterIndex];
    }
    return closestBeforeIndex >= 0 ? scrollMenuItems[closestBeforeIndex] : (closestAfterIndex >= 0 && scrollMenuItems[closestAfterIndex]);
  };

  const selectMenu = (scrollMenuItem, updateLocation) => {
    if (scrollMenuItem !== lastSelectedScrollMenuItem) {
      if (lastSelectedScrollMenuItem) {
        removeClass(lastSelectedScrollMenuItem.li, 'active');
      }
      lastSelectedScrollMenuItem = scrollMenuItem;
      if (lastSelectedScrollMenuItem) {
        addClass(lastSelectedScrollMenuItem.li, 'active');
        if (updateLocation) {
          onUpdateLocation(`${location.pathname}#${lastSelectedScrollMenuItem.scrollItem.id}`);
        }
      }
    }
  };

  const updateMenuSelection = (updateLocation) => {
    // console.log(`updateMenuSelection on ${mainElt.scrollTop}`);
    const closestScollMenuItem = getClosestScrollMenuItem(mainElt.scrollTop);
    selectMenu(closestScollMenuItem, updateLocation);
  };

  const adjustMainRightPadding = () => {
    const navWidth = menuElt.offsetWidth;
    const mainEltMut = mainElt;
    if (navWidth < MIN_NAV_WIDTH) {
      mainEltMut.style.paddingRight = `${MIN_NAV_WIDTH}px`;
      const menuEltMut = menuElt;
      menuEltMut.style.marginRight = `${MIN_NAV_WIDTH - navWidth}px`;
    } else {
      mainEltMut.style.paddingRight = `${Math.max(MIN_NAV_WIDTH, navWidth)}px`;
    }
  };

  // If URL references a section, scroll to it and update selection
  const { hash } = location;
  let scrollToSection;
  if (hash.length > 1) {
    const toFind = hash.substring(1);
    scrollToSection = scrollMenuItems.find((si) => {
      return si.scrollItem.id === toFind;
    });
  }
  if (scrollToSection) {
    selectMenu(scrollToSection);
    mainElt.scrollTop = scrollToSection.scrollItem.getBoundingClientRect().top
      - mainElt.getBoundingClientRect().top;
  } else {
    updateMenuSelection();
  }

  const mainEltMut = mainElt;
  mainEltMut.addEventListener('scroll', () => {
    updateMenuSelection(true);
  });
  adjustMainRightPadding();
}

export default handleMenu;
